import { render, staticRenderFns } from "./Semantics.html?vue&type=template&id=274e520c&scoped=true&"
import script from "./Semantics.vue?vue&type=script&lang=js&"
export * from "./Semantics.vue?vue&type=script&lang=js&"
import style0 from "./Semantics.vue?vue&type=style&index=0&id=274e520c&scoped=true&lang=css&"
import style1 from "./Semantics.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274e520c",
  null
  
)

export default component.exports